import { http } from "@/utils/http";

export const getChannelRaw = async key => {
  const channels = await http.request("get", "/rest/channels", {
    params: {
      query: JSON.stringify({
        key
      }),
      populate: JSON.stringify([
        {
          path: "features.tpHotel.negotiateds.tagRefs",
          populate: ["nameRef"]
        },
        "features.tpHotel.negotiateds.benefitsRef"
      ])
    }
  });
  return channels;
};

export const getChannelList = data => {
  return http.request("get", "/rest/channels", { params: data });
};

/**
 * 获取渠道详情
 * @param {String} id 渠道ID
 * @param {Object} query 查询数据
 * @returns
 */
export const getChannelDetail = async (id, query = {}) => {
  return http.request("get", `/rest/channels/${id}`, {
    params: {
      ...query
    }
  });
};
